// Fork-local (Asthara): the agent's WhatsApp number for assignment notifications, stored in
// users.custom_attributes.phone_number. Mirrors the backend rule in
// app/models/concerns/user_phone_number.rb: separators are stripped and the number must keep its
// country code (+62...), so a local 0812... is rejected instead of guessed. Empty = no notifications.
const SEPARATORS = /[\s\-().]/g;
const INTERNATIONAL_FORMAT = /^\+[1-9]\d{7,14}$/;

export const normalizeAgentPhoneNumber = value =>
  String(value ?? '').replace(SEPARATORS, '');

export const isValidAgentPhoneNumber = value => {
  const normalized = normalizeAgentPhoneNumber(value);
  return normalized === '' || INTERNATIONAL_FORMAT.test(normalized);
};
